import { useCallback, useEffect, useMemo, useState } from "react";
import {
  ADMIN_UNREAD_UPDATED_EVENT,
  getAdminUnreadCounts,
} from "services/adminUnreadService";

const EMPTY_COUNTS = {};

const normalizeCounts = (responseCounts = {}) =>
  Object.entries(responseCounts).reduce((acc, [module, value]) => {
    acc[module] = {
      ...value,
      count: Number(value?.count ?? value?.totalNewCount) || 0,
    };
    return acc;
  }, {});

const useAdminUnreadCounts = (modules = []) => {
  const [counts, setCounts] = useState(EMPTY_COUNTS);
  const [loading, setLoading] = useState(false);
  const moduleKey = useMemo(() => modules.join(","), [modules]);
  const moduleList = useMemo(() => (moduleKey ? moduleKey.split(",") : []), [moduleKey]);

  const refreshCounts = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getAdminUnreadCounts(moduleList);
      setCounts(normalizeCounts(response?.data?.counts));
    } catch (error) {
      console.error("Error fetching admin unread counts:", error);
      setCounts(EMPTY_COUNTS);
    } finally {
      setLoading(false);
    }
  }, [moduleList]);

  useEffect(() => {
    refreshCounts();

    window.addEventListener("focus", refreshCounts);
    window.addEventListener(ADMIN_UNREAD_UPDATED_EVENT, refreshCounts);

    return () => {
      window.removeEventListener("focus", refreshCounts);
      window.removeEventListener(ADMIN_UNREAD_UPDATED_EVENT, refreshCounts);
    };
  }, [refreshCounts]);

  return {
    counts,
    loading,
    refreshCounts,
    getCount: (module) => Number(counts[module]?.count) || 0,
    getModuleCount: (module) => counts[module] || { count: 0 },
  };
};

export default useAdminUnreadCounts;
